import {
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from "class-validator";
import { validationRegExpr } from "@shared/constants/validations-regexp";

@ValidatorConstraint({ name: "passwordStrength", async: false })
export class PasswordStrength implements ValidatorConstraintInterface {
  validate(text: string) {
    return (
      !!text &&
      text.length >= 8 &&
      validationRegExpr.oneUpperCase.test(text) &&
      validationRegExpr.specialAndDigitChar.test(text)
    );
  }

  defaultMessage() {
    return `Your password needs to meet the requirements`;
  }
}
